<template>
  <div
    class="d-inline-block"
    :class="[{ 'pl-2': $vuetify.breakpoint.xsOnly }, { 'pl-3': $vuetify.breakpoint.smAndUp }]"
  >
    <div
      v-if="mobile"
      class="mobile-btn"
    >
      <v-tooltip
        bottom
        max-width="300"
      >
        <template #activator="{ on }">
          <v-btn
            fab
            small
            dark
            :color="parentStatus.color"
            class="mt-2"
            v-on="on"
          >
            {{ parentStatus.description.substr(0, 1).toUpperCase() }}
          </v-btn>
        </template>
        <span class="f-14">{{ parentStatus.description }}</span>
      </v-tooltip>
    </div>
    <div v-else>
      <v-tooltip
        bottom
        style="width: 100%"
      >
        <template
          slot="activator"
          slot-scope="{ on }"
        >
          <div v-on="on">
            <v-layout
              align-center
              justify-start
              row
              fill-height
            >
              <v-flex>
                <v-chip
                  :color="parentStatus.color"
                  class="white--text mr-2 desktop-chip"
                />
              </v-flex>
              <v-flex>
                <span>{{ parentStatus.description }}</span>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex
                v-for="(substatus, index) in currentStatus.substatusAmount"
                :key="index"
                xs6
                class="mx-1"
              >
                <v-chip
                  v-if="substatus <= currentStatus.substatusOrder"
                  :color="parentStatus.color"
                  class="desktop-thin-chip"
                />
                <v-chip
                  v-else
                  height="5"
                  outline
                  color="#DCE2E7"
                  class="desktop-thin-chip"
                />
              </v-flex>
            </v-layout>
          </div>
        </template>
        <span>{{ currentStatus.description }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
    name: 'FamilyStatus',
    props: {
        mobile: {
            default: true,
            type: Boolean
        },
        status: {
            default: null
        }
    },
    computed: {
        currentStatus () {
            return this.statusObject(this.status);
        },
        parentStatus () {
            if (this.status.parent === null) {
                return this.currentStatus;
            }
            return this.statusObject(this.status.parent);
        }
    },
    methods: {
        statusObject (status) {
            if (status == null) {
                return {
                    description: '',
                    substatusAmount: '',
                    substatusOrder: '',
                    color: '#' + ''
                };
            }
            return {
                description: status.description,
                substatusAmount: status.substatus_amount,
                substatusOrder: status.substatus_order,
                color: '#' + status.color
            };
        }
    }
};
</script>

<style lang="scss">
.mobile-btn {
  .v-btn__content {
    padding-top: 2px;
  }
  .v-btn--floating:not(.v-btn--depressed):not(.v-btn--flat) {
    height: 19px;
    width: 19px;
    box-shadow: unset;
  }
}
.desktop-chip {
  height: 12px;
  width: 12px;
}
.desktop-thin-chip {
  width: 100%;
  height: 5px;
}
.v-chip.v-chip.v-chip--outline {
  height: 5px !important;
}
</style>
